<template>
  <Container>
    <template #header>
      <Header :menu="$page.props.main_menu" v-if="$page.props.auth.user" />
    </template>
    <template #default>
      <div class="container px-4 mx-auto">
        <Breadcrumbs
          :breadcrumbs="[
            { name: 'Dashboard', href: route('dashboard') },
            { name: 'Pemilihan', href: route('pemilihan.index') },
          ]"
        />
        <div class="grid grid-cols-1 gap-6 leading-6 lg:grid-cols-3">
          <div class="order-2 col-span-1 space-y-6 lg:order-1">
            <div>
              <div class="bg-white border border-gray-200 shadow-lg rounded-xl">
                <div
                  class="px-4 py-3 border-b border-gray-200 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-t-xl sm:px-6 sm:py-4"
                >
                  <h2
                    class="flex items-center text-lg font-bold text-white sm:text-xl"
                  >
                    <i class="mr-2 fa-solid fa-check-to-slot sm:mr-3"></i>
                    Tambah Kegiatan Pemilihan
                  </h2>
                </div>
                <div class="p-4 sm:p-6">
                  <form class="space-y-4" @submit.prevent="submit">
                    <div v-if="form.imagePreview.length">
                      <p class="mb-2 font-medium">Preview Gambar:</p>
                      <div class="flex flex-wrap gap-2">
                        <img
                          v-for="(src, index) in form.imagePreview"
                          :key="index"
                          :src="src"
                          class="object-cover w-32 h-32 rounded"
                        />
                      </div>
                    </div>

                    <div>
                      <label class="block text-sm font-medium text-gray-700"
                        >Judul Kegiatan</label
                      >
                      <input
                        v-model="form.judul"
                        type="text"
                        class="block w-full px-3 py-2.5 mt-1 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400 transition-colors duration-200"
                      />
                      <InputError :message="form.errors.judul" class="mt-2" />
                    </div>

                    <div>
                      <label class="block mb-1 text-sm font-medium text-gray-700"
                        >Keterangan</label
                      >
                      <QuillEditor
                        v-model="form.keterangan"
                        :error="form.errors.keterangan"
                      />
                    </div>

                    <div>
                      <label class="block text-sm font-medium text-gray-700"
                        >Tanggal Mulai</label
                      >
                      <input
                        v-model="form.tanggal_mulai"
                        type="date"
                        class="block w-full px-3 py-2.5 mt-1 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400 transition-colors duration-200"
                      />
                      <InputError
                        :message="form.errors.tanggal_mulai"
                        class="mt-2"
                      />
                    </div>
                    <div>
                      <label class="block text-sm font-medium text-gray-700"
                        >Tanggal Selesai</label
                      >
                      <input
                        v-model="form.tanggal_selesai"
                        type="date"
                        class="block w-full px-3 py-2.5 mt-1 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400 transition-colors duration-200"
                      />
                      <InputError
                        :message="form.errors.tanggal_selesai"
                        class="mt-2"
                      />
                    </div>

                    <div>
                      <label class="block text-sm font-medium text-gray-700"
                        >Gambar</label
                      >
                      <input
                        type="file"
                        ref="imageInput"
                        accept="image/*"
                        multiple
                        @change="handleImageChange"
                        class="block w-full px-3 py-2.5 mt-1 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm cursor-pointer focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400 transition-colors duration-200 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-medium file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100"
                      />
                      <InputError :message="form.errors.gambar" class="mt-2" />
                    </div>

                    <div>
                      <label class="block text-sm font-medium text-gray-700"
                        >Lampiran Pengumuman</label
                      >
                      <input
                        type="file"
                        ref="lampiranPengumumanInput"
                        accept=".pdf,.doc,.docx"
                        multiple
                        @change="handleLampiranPengumumanChange"
                        class="block w-full px-3 py-2.5 mt-1 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm cursor-pointer focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400 transition-colors duration-200 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-medium file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100"
                      />
                      <div
                        v-if="form.lampiran_pengumuman_file.length"
                        class="mt-2 space-y-2"
                      >
                        <div
                          v-for="(file, i) in form.lampiran_pengumuman_file"
                          :key="i"
                          class="flex items-center gap-2"
                        >
                          <span
                            class="flex-shrink-0 text-xs text-gray-500 truncate w-28"
                            :title="file.name"
                            >{{ file.name }}</span
                          >
                          <input
                            v-model="form.lampiran_pengumuman_nama[i]"
                            type="text"
                            placeholder="Nama lampiran"
                            class="block w-full px-3 py-1.5 text-sm text-gray-900 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                          />
                        </div>
                      </div>
                      <InputError
                        :message="form.errors.lampiran_pengumuman_nama"
                        class="mt-2"
                      />
                    </div>

                    <div>
                      <label class="block text-sm font-medium text-gray-700"
                        >Lampiran Dokumen</label
                      >
                      <input
                        type="file"
                        ref="lampiranDokumenInput"
                        accept=".pdf,.doc,.docx"
                        multiple
                        @change="handleLampiranDokumenChange"
                        class="block w-full px-3 py-2.5 mt-1 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm cursor-pointer focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400 transition-colors duration-200 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-medium file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100"
                      />
                      <div
                        v-if="form.lampiran_dokumen_file.length"
                        class="mt-2 space-y-2"
                      >
                        <div
                          v-for="(file, i) in form.lampiran_dokumen_file"
                          :key="i"
                          class="flex items-center gap-2"
                        >
                          <span
                            class="flex-shrink-0 text-xs text-gray-500 truncate w-28"
                            :title="file.name"
                            >{{ file.name }}</span
                          >
                          <input
                            v-model="form.lampiran_dokumen_nama[i]"
                            type="text"
                            placeholder="Nama lampiran"
                            class="block w-full px-3 py-1.5 text-sm text-gray-900 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                          />
                        </div>
                      </div>
                      <InputError
                        :message="form.errors.lampiran_dokumen_nama"
                        class="mt-2"
                      />
                    </div>

                    <div>
                      <label class="block text-sm font-medium text-gray-700"
                        >Status</label
                      >
                      <select
                        v-model="form.status"
                        class="block w-full px-3 py-2.5 mt-1 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm appearance-none focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400 transition-colors duration-200"
                      >
                        <option value="">Pilih</option>
                        <option value="terjadwal">Terjadwal</option>
                        <option value="berlangsung">Berlangsung</option>
                        <option value="selesai">Selesai</option>
                        <option value="dibatalkan">Batal</option>
                      </select>
                      <InputError :message="form.errors.status" class="mt-2" />
                    </div>

                    <div class="pt-4">
                      <button
                        type="submit"
                        :disabled="form.processing"
                        class="w-full px-4 py-2.5 text-sm font-semibold text-white bg-indigo-600 border border-transparent rounded-lg shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
                      >
                        <i class="mr-2 fa-solid fa-floppy-disk"></i>
                        {{ form.processing ? "Menyimpan..." : "Simpan" }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div class="order-1 col-span-1 lg:col-span-2 lg:order-2">
            <div class="mb-4 sm:mb-6">
              <div
                class="flex flex-col sm:flex-row sm:items-center sm:justify-between"
              >
                <div>
                  <h3 class="text-lg font-semibold text-gray-900">
                    Daftar Kegiatan Pemilihan
                  </h3>
                  <p class="mt-1 text-sm text-gray-600">
                    Kelola kegiatan pemilihan
                  </p>
                </div>
                <div class="mt-2 text-sm text-gray-500 sm:mt-0">
                  Total: {{ pemilihans.total || 0 }} kegiatan
                </div>
              </div>
            </div>
            <div class="relative mb-4">
              <div
                class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none"
              >
                <MagnifyingGlassVue class="w-4 h-4 text-gray-400" />
              </div>
              <input
                v-model="search"
                type="text"
                autocomplete="off"
                placeholder="Search data..."
                class="block w-full px-3 py-2.5 pl-10 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400 transition-colors duration-200"
              />
            </div>
            <div
              class="overflow-hidden bg-white shadow ring-1 ring-black ring-opacity-5 md:rounded-lg"
            >
              <div class="overflow-x-auto">
                <table class="min-w-full divide-y divide-gray-300">
                  <thead class="bg-gray-50">
                    <tr>
                      <th
                        scope="col"
                        class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                      >
                        #
                      </th>
                      <th
                        scope="col"
                        class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 min-w-[150px]"
                      >
                        Judul
                      </th>
                      <th
                        scope="col"
                        class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 min-w-[120px]"
                      >
                        Tanggal Mulai
                      </th>
                      <th
                        scope="col"
                        class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 hidden sm:table-cell min-w-[120px]"
                      >
                        Tanggal Selesai
                      </th>
                      <th
                        scope="col"
                        class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 min-w-[100px]"
                      >
                        Status
                      </th>
                      <th
                        scope="col"
                        class="relative py-3.5 pl-3 pr-4 sm:pr-6 min-w-[100px]"
                      >
                        <span class="sr-only">Actions</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200">
                    <tr v-if="!pemilihans.data || pemilihans.data.length === 0">
                      <td colspan="6" class="px-6 py-12 text-center">
                        <div class="flex flex-col items-center justify-center">
                          <i
                            class="mb-3 text-4xl text-gray-400 fa-solid fa-check-to-slot"
                          ></i>
                          <h3 class="text-lg font-medium text-gray-900">
                            Tidak ada kegiatan pemilihan
                          </h3>
                          <p class="mt-1 text-sm text-gray-500">
                            Belum ada kegiatan pemilihan yang ditambahkan.
                          </p>
                        </div>
                      </td>
                    </tr>
                    <tr
                      v-for="(item, index) in pemilihans.data || []"
                      :key="item.idpemilihan"
                      class="transition-colors duration-150 hover:bg-gray-50"
                    >
                      <td
                        class="py-4 pl-4 pr-3 text-sm font-medium text-gray-900 whitespace-nowrap sm:pl-6"
                      >
                        {{ getRowNumber(index) }}
                      </td>
                      <td class="px-3 py-4 text-sm text-gray-900">
                        <div class="font-medium">{{ item.judul }}</div>
                      </td>
                      <td
                        class="px-3 py-4 text-sm text-gray-500 whitespace-nowrap"
                      >
                        {{ item.tanggal_mulai }}
                      </td>
                      <td
                        class="hidden px-3 py-4 text-sm text-gray-500 whitespace-nowrap sm:table-cell"
                      >
                        {{ item.tanggal_selesai || "-" }}
                      </td>
                      <td class="px-3 py-4 text-sm whitespace-nowrap">
                        <span
                          :class="{
                            'bg-green-100 text-green-800':
                              item.status === 'selesai',
                            'bg-blue-100 text-blue-800':
                              item.status === 'terjadwal',
                            'bg-yellow-100 text-yellow-800':
                              item.status === 'berlangsung',
                            'bg-red-100 text-red-800':
                              item.status === 'dibatalkan',
                          }"
                          class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium capitalize lg:px-2.5"
                        >
                          {{ item.status }}
                        </span>
                      </td>
                      <td
                        class="relative py-4 pl-3 pr-4 text-sm font-medium text-right sm:pr-6"
                      >
                        <div
                          class="flex items-center justify-end space-x-1 sm:space-x-2"
                        >
                          <Link
                            :href="route('pemilihan.show', item.idpemilihan)"
                            class="inline-flex items-center px-2 py-1 text-xs font-medium text-indigo-600 bg-indigo-100 rounded-md hover:bg-indigo-200 hover:text-indigo-700 transition-colors duration-150 sm:px-2.5 sm:py-1.5"
                            title="Detail"
                          >
                            <EditIcons class="w-3 h-3" />
                            <span class="hidden ml-1 sm:inline">Detail</span>
                          </Link>
                          <button
                            @click="deletePemilihan(item)"
                            class="inline-flex items-center px-2 py-1 text-xs font-medium text-red-600 bg-red-100 rounded-md hover:bg-red-200 hover:text-red-700 transition-colors duration-150 sm:px-2.5 sm:py-1.5"
                            title="Delete"
                          >
                            <DeleteIcons class="w-3 h-3" />
                            <span class="hidden ml-1 sm:inline">Delete</span>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div
              v-if="pemilihans.last_page && pemilihans.last_page > 1"
              class="flex justify-center mt-6"
            >
              <Pagination
                :data="pemilihans"
                :updatedPageNumber="updatedPageNumber"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
  </Container>
</template>
<script setup>
import { ref, computed, watch } from "vue";
import Container from "@/Layouts/Container.vue";
import QuillEditor from "@/Components/QuillEditor.vue";
import Pagination from "@/Components/Pagination.vue";
import Header from "@/Components/Header.vue";
import Breadcrumbs from "@/Components/Breadcrumbs.vue";
import InputError from "@/Components/InputError.vue";
import EditIcons from "@/Components/Icons/EditIcons.vue";
import DeleteIcons from "@/Components/Icons/DeleteIcons.vue";
import MagnifyingGlassVue from "@/Components/MagnifyingGlass.vue";
import Swal from "sweetalert2";

import { Link, useForm, router, usePage } from "@inertiajs/vue3";
const props = defineProps({
  pemilihans: {
    type: Object,
    required: true,
  },
});

let search = ref(usePage().props.search || ""),
  pageNumber = ref(1);

let pemilihanUrl = computed(() => {
  let url = new URL(route("pemilihan.index"));
  url.searchParams.append("page", pageNumber.value);
  if (search.value) {
    url.searchParams.append("search", search.value);
  }
  return url;
});

const getRowNumber = computed(() => {
  return (index) => {
    const currentPage = props.pemilihans?.current_page || 1;
    const perPage = props.pemilihans?.per_page || 10;
    return (currentPage - 1) * perPage + index + 1;
  };
});

const updatedPageNumber = (link) => {
  pageNumber.value = link.url.split("=")[1];
};

watch(
  () => pemilihanUrl.value,
  (updatedUrl) => {
    router.visit(updatedUrl, {
      preserveScroll: true,
      preserveState: true,
      replace: true,
    });
  }
);

watch(
  () => search.value,
  (value) => {
    if (value) {
      pageNumber.value = 1;
    }
  }
);

const form = useForm({
  judul: "",
  keterangan: "",
  tanggal_mulai: "",
  tanggal_selesai: "",
  status: "",
  gambar: [],
  imagePreview: [],
  lampiran_pengumuman_file: [],
  lampiran_pengumuman_nama: [],
  lampiran_dokumen_file: [],
  lampiran_dokumen_nama: [],
});

function handleImageChange(e) {
  const files = Array.from(e.target.files);
  form.gambar = files;
  form.imagePreview = files.map((file) => URL.createObjectURL(file));
}

function handleLampiranPengumumanChange(e) {
  form.lampiran_pengumuman_file = Array.from(e.target.files);
  form.lampiran_pengumuman_nama = form.lampiran_pengumuman_file.map(() => "");
}

function handleLampiranDokumenChange(e) {
  form.lampiran_dokumen_file = Array.from(e.target.files);
  form.lampiran_dokumen_nama = form.lampiran_dokumen_file.map(() => "");
}

const imageInput = ref(null);
const lampiranPengumumanInput = ref(null);
const lampiranDokumenInput = ref(null);

const deleteForm = useForm({});
const deletePemilihan = (item) => {
  Swal.fire({
    title: "Apakah Anda yakin?",
    text: `Kegiatan "${item.judul}" akan dihapus secara permanen!`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#dc2626",
    cancelButtonColor: "#6b7280",
    confirmButtonText: "Ya, hapus!",
    cancelButtonText: "Batal",
  }).then((result) => {
    if (result.isConfirmed) {
      deleteForm.delete(route("pemilihan.destroy", item.idpemilihan), {
        onSuccess: () => {
          Swal.fire({
            title: "Berhasil!",
            text: "Kegiatan berhasil dihapus.",
            icon: "success",
            confirmButtonText: "OK",
          });
        },
        onError: () => {
          Swal.fire({
            title: "Gagal!",
            text: "Terjadi kesalahan saat menghapus kegiatan.",
            icon: "error",
            confirmButtonText: "OK",
          });
        },
      });
    }
  });
};

const submit = () => {
  form.post(route("pemilihan.store"), {
    forceFormData: true,
    onSuccess: () => {
      Swal.fire({
        title: "Berhasil!",
        text: "Kegiatan pemilihan berhasil disimpan.",
        icon: "success",
        confirmButtonText: "OK",
      }).then(() => {
        form.reset();
        form.gambar = [];
        form.imagePreview = [];
        form.lampiran_pengumuman_file = [];
        form.lampiran_pengumuman_nama = [];
        form.lampiran_dokumen_file = [];
        form.lampiran_dokumen_nama = [];
        if (imageInput.value) imageInput.value.value = "";
        if (lampiranPengumumanInput.value) lampiranPengumumanInput.value.value = "";
        if (lampiranDokumenInput.value) lampiranDokumenInput.value.value = "";
      });
    },
    onError: () => {
      Swal.fire({
        title: "Gagal!",
        text: "Terjadi kesalahan saat menyimpan data.",
        icon: "error",
        confirmButtonText: "OK",
      });
    },
  });
};
</script>
